export default {
  item: state => state.item,
  index: state => state.index,
  products: state => state.products,
  loading: state => state.loading,
  items: state => state.items
};